import './Pictures.scss';

import React, { useEffect, useRef, useState } from 'react';

import TIP from '../../../../../../../assets/images/MembersArea/amber.jpg';
import drag_and_drop from '../../../../../../../assets/images/MembersArea/MyProfile/drag_and_drop.svg';
import DragAndDrop from '../../../../../../../components/DragAndDrop/DragAndDrop';
// import ImageNPreview from "../../../../../../../components/ImageNPreview/ImageNPreview";
// import ImageN from "../../../../../../../components/ImageN/ImageN";
import LoaderComponent from '../../../../../../../components/LoaderCompoment/LoaderComponent';
import { getToken } from '../../../../../../../services/token-service/token.service';
import {
  getUserData,
  getUserProfileWithGallery,
} from '../../../../../../../services/user-service/user.service';
import GalleryImages from '../Pictures/GalleryImages/GalleryImages';
// import { Image, Modal } from "antd";
import ProfileNav from '../ProfileNav/ProfileNav';

const Pictures = () => {
  const token = getToken();
  const userData = getUserData();
  const profilePhoto = useRef();
  const [userID, getUserID] = useState(userData?.profile.id);
  const [galleryImages, setGalleryImages] = useState('');
  const [loader, setLoader] = useState(true);
  const [currentPhoto, setCurrentPhoto] = useState(userData?.profile?.avatar_image?.thumbnail_url);
  const [currentPhotoFullSize, setCurrentPhotoFullSize] = useState(
    userData?.profile?.avatar_image?.url,
  );

  useEffect(() => {
    getUserProfileWithGallery(userID)
      .then((data) => {
        setGalleryImages(data.data.data.gallery_images);
        setLoader(false);
      })
      .catch((err) => console.log(err));
  }, [loader, userID]);

  return (
    <div>
      <ProfileNav />
      <div className="PicturesWrapper">
        {
          <div className="ProfilePhoto">
            <p className="ProfilePhotoText">Profile Photo</p>
            {loader ? (
              <div className="LoaderComponentWrapper">
                <LoaderComponent />
              </div>
            ) : userData?.profile?.avatar_image?.thumbnail_url ? (
              <div>
                <DragAndDrop
                  currentPhoto={currentPhoto}
                  currentPhotoFullSize={currentPhotoFullSize}
                  setCurrentPhoto={setCurrentPhoto}
                  fileRef={profilePhoto}
                  userID={userID}
                  multiple={false}
                  type={'profile_image'}
                  className={'change-photo'}
                  btnclasses={'btn-change-photo'}
                  successMessage={'Profile photo updated!'}
                  failureMessage={'Profile photo update failed!'}
                  dndImage={drag_and_drop}
                  text={'Drag and drop an image, or Browse'}
                  btnText={'Upload'}
                />
              </div>
            ) : (
              <div className="DragAndDropWrapper">
                <DragAndDrop
                  fileRef={profilePhoto}
                  userID={userID}
                  multiple={false}
                  type={'profile_image'}
                  text={'Drag and drop an image, or Browse'}
                  btnText={'Upload'}
                  dndImage={drag_and_drop}
                  successMessage={'Profile photo updated!'}
                  failureMessage={'Profile photo failed!'}
                  currentPhoto={currentPhoto}
                  currentPhotoFullSize={currentPhotoFullSize}
                  setCurrentPhotoFullSize={setCurrentPhotoFullSize}
                  setCurrentPhoto={setCurrentPhoto}
                />
              </div>
            )}
          </div>
        }
        <div className="AdditionalPhotosWrapper">
          <div className={'Tip'}>
            <div className="image-box">
              <img onContextMenu={(e) => e.preventDefault()} src={TIP} alt="tip" />
            </div>
            <p className="TipText">
              Amber’s Tip: Adding photos makes it more likely you will get matches. Members want to
              see you just as much as you want to see them.
            </p>
          </div>
          <p className="AdditionalPhotosText">Add Additional Photos</p>
          <GalleryImages />

          {/* <div className="GalleryPhotosWrapper">
            {loader ? (
              <div className="LoaderComponentWrapper">
                <LoaderComponent />
              </div>
            ) : galleryImages?.length ? (
              <div className="GalleryPhotoContainerOuter">
                <div className="GalleryPhotoContainer">
                  {galleryImages?.map((img, index) => {
                    if (img.type === "gallery") {
                      return (
                        <div className="ImageGalleryContainer" key={index}>
                          <ImageN name={img.url} classNameImg="GalleryPhoto" />
                        </div>
                      );
                    }
                  })}
                </div>
                <DragAndDrop
                  userID={userID}
                  multiple={true}
                  type={"gallery_images"}
                  btnText={"Add new"}
                  className={"additional-photos"}
                  textClasses={"additional-text"}
                  successMessage={"Successfully added photos!"}
                  fileRef={albumPhotos}
                  failureMessage={"Adding photo failed!"}
                />
              </div>
            ) : (
              <div className="AdditionalPhotosContainer">
                <DragAndDrop
                  text={"No additional photo"}
                  fileRef={albumPhotos}
                  userID={userID}
                  multiple={true}
                  type={"gallery_images"}
                  btnText={"Add new"}
                  className={"additional-photos"}
                  textClasses={"additional-text"}
                  successMessage={"Successfully added photos!"}
                  failureMessage={"Adding photo failed!"}
                />
              </div>
            )}
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Pictures;
